/* global graphql */
import React from 'react'
import Meta from '../components/Meta'
import { ListGridBanner, ListGridBannerMinor } from '../components/Banners'
import { ListGridItem } from '../components/PageHelpers'

const ArtsCultureGrid = ({ data }) => {
  const page = data.mortyPage

  // Filter out Featured Events page
  let allPages
  if (data.allArtsCulture && data.allArtsCulture.edges) {
    allPages = data.allArtsCulture.edges.filter(p => p.node.title !== 'Featured Events')
  }

  // If there are events, add them to the data
  let gridData
  if (allPages) {
    gridData = allPages.concat(data.allArtsCulture.edges)
  }

  // Force ordering
  const pageRoutes = [
    '/explore-downtown/arts-and-culture/theaters-and-music/',
    '/explore-downtown/arts-and-culture/art-galleries/',
    '/explore-downtown/arts-and-culture/richmond-street-art/'
  ]

  const orderedPages = []
  if (gridData) {
    pageRoutes.forEach((route, _) => {
      const pgData = gridData.find(obj => obj.node.route === route)
      orderedPages.push(pgData)
    })
  }
  // Filter out undefined values
  const filteredPages = orderedPages.filter(Boolean)

  // Render blocks
  let blocks
  if (filteredPages) {
    blocks = filteredPages.map(d => <ListGridItem key={d.node.id} page={d.node} />)
  }

  // Render banner
  const Banner = ({ page }) => {
    if (
      page.title !== 'Live Downtown' &&
      page.title !== 'Explore Downtown' &&
      page.title !== 'Work Downtown'
    ) {
      return <ListGridBannerMinor page={page} />
    }
    return <ListGridBanner page={page} />
  }

  return (
    <div>
      <Meta page={page} />
      <Banner page={page} />
      <div className='pv3 pv4-m pv5-l flex items-center justify-center'>
        <div className='w-100'>
          {blocks}
        </div>
      </div>
    </div>
  )
}

export default ArtsCultureGrid

export const pageQuery = graphql`
query ArtsCultureGrid($id: String!) {
  mortyPage(id: { eq: $id }) {
    title
    route
    subtitle
    route
    metaTitle
    metaDescription
    metaKeywords
    abstract
    abstractPhotoAltText
    abstractPhotoFocalPointX
    abstractPhotoFocalPointY
    abstractPhoto {
      url
    }
  }
  allArtsCulture: allMortyPage(filter: {
    route: { ne: "/dummy-page" }
    section: { eq: "Arts and Culture" }
}) {
    edges {
      node {
        id
        title
        route
        section
        abstract
        template
        abstractPhotoAltText
        abstractPhotoFocalPointX
        metaDescription
        abstractPhotoFocalPointY
        abstractPhoto {
          url
        }
      }
    }
  }
}
`

export const previewQuery = `
query ArtsCultureGrid($id: String!) {
  mortyPage(id: { eq: $id }) {
    title
    route
    subtitle
    route
    metaTitle
    metaDescription
    metaKeywords
  }
  allArtsCulture: allMortyPage(filter: {
    route: { ne: "/dummy-page" }
    section: { eq: "Arts and Culture" }
}) {
    edges {
      node {
        id
        title
        route
        section
        abstract
        template
        abstractPhotoAltText
        abstractPhotoFocalPointX
        metaDescription
        abstractPhotoFocalPointY
        abstractPhoto {
          url
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/templates/Arts-Culture-Grid.js